// export const filterCurrency = {
//     '156':'人民币',
//     '344':'港元',
//     '840':'美元',
//     '978':'欧元',
//     '756':'瑞士法郎',
//     '702':'新加坡元',
//     '410':'韩元',
//     '826':'英镑',
//     '392':'日元',
//     '036':'澳大利亚元',
//     '784':'UAE迪拉姆',
//     '124':'加拿大元',
//     '398':'坚戈',
//     '356':'印度卢比',
//     '999':'其它',
//     '032':'阿根廷比索',
// }

// 货币类型
const filterCurrency = (value) => {
  switch (value) {
    case '156':
      return '人民币';
    case '344':
      return '港元';
    case '840':
      return '美元';
    case '978':
      return '欧元';
    case '756':
      return '瑞士法郎';
    case '702':
      return '新加坡元';
    case '410':
      return '韩元';
    case '826':
      return '英镑';
    case '392':
      return '日元';
    case '036':
      return '澳大利亚元';
    case '784':
      return 'UAE迪拉姆';
    case '398':
      return '坚戈';
    case '356':
      return '印度卢比';
    case '999':
      return '其它';
    case '032':
      return '阿根廷比索';
    default:
      return '';
  }
};

// 证件类型
// let certificateType = value => {
//     switch(value){
// 		case "101":
// 			return "身份证";
// 		case "102":
// 			return "护照";
// 		case "104":
// 			return "组织机构代码";
//         case "103":
//             return "其他";
//         case "104":
//             return "台湾（港澳）居民来往大陆通行证";
// 		default:
// 			return "";
// 	}
// }
const certificateType = {
  101: '身份证',
  102: '护照',
  104: '组织机构代码',
  103: '其他',
  104: '台湾（港澳）居民来往大陆通行证',
};

// 时间格式处理
const dateformate = (data, format) => {
  if (!data) {
    return '';
  }
  if (typeof data === 'string') {
    data = data.replace(/-/g, '/');
  }
  data = new Date(data);
  const o = {
    'M+': data.getMonth() + 1, // month
    'd+': data.getDate(), // day
    'h+': data.getHours(), // hour
    'm+': data.getMinutes(), // minute
    's+': data.getSeconds(), // second
    'q+': Math.floor((data.getMonth() + 3) / 3), // quarter
    S: data.getMilliseconds(), // millisecond
  };
  if (/(y+)/.test(format)) {
    format = format.replace(
      RegExp.$1,
      `${data.getFullYear()}`.substr(4 - RegExp.$1.length)
    );
  }
  for (const k in o) {
    if (new RegExp(`(${k})`).test(format)) {
      format = format.replace(
        RegExp.$1,
        RegExp.$1.length == 1 ? o[k] : `00${o[k]}`.substr(`${o[k]}`.length)
      );
    }
  }
  return format;
};

/*
 *	当前日期的前一天
 */
const preDate = (curDate = new Date(), formate) => {
  let _preDate = new Date(curDate.getTime() - 24 * 60 * 60 * 1000); // 前一天
  if (formate) {
    _preDate = dateformate(_preDate, formate);
  }
  return _preDate;
};

const templateControlData = {
  bannerList: [],
  transformersList: [],
  informationList: {
    nociteList: [],
    newsList: [],
  },
  recommendList: [],

  categoryList: [],
  brandList: [],
  // characteristicList:[{
  //     productId:1,
  //     productName:'MRO采购专区',
  //     describe:'',
  //     imgUrl:require('../../static/characteristicUnit/zhuanqu1.png'),
  //     linkUrl:'https://mall.epec.com/ecmall/static/mro1.do'
  // },{
  //     productId:2,
  //     productName:'钢铁采购专区',
  //     describe:'',
  //     imgUrl:require('../../static/characteristicUnit/zhuanqu2.png'),
  //     linkUrl:'https://mall.epec.com/ecmall/static/gtZone.do'
  // },{
  //     productId:3,
  //     productName:'阀门采购专区',
  //     describe:'',
  //     imgUrl:require('../../static/characteristicUnit/zhuanqu3.png'),
  //     linkUrl:'https://mall.epec.com/ecmall/static/fmZone.do'
  // },{
  //     productId:4,
  //     productName:'劳动防护专区',
  //     describe:'',
  //     imgUrl:require('../../static/characteristicUnit/zhuanqu4.png'),
  //     linkUrl:'https://mall.epec.com/ecmall/static/nlbZone.do'
  // },{
  //     productId:5,
  //     productName:'工业汽车专区',
  //     describe:'',
  //     imgUrl:require('../../static/characteristicUnit/zhuanqu5.png'),
  //     linkUrl:'https://mall.epec.com/ecmall/static/Vehicle.do'
  // },{
  //     productId:6,
  //     productName:'电工材料专区',
  //     describe:'',
  //     imgUrl:require('../../static/characteristicUnit/zhuanqu6.png'),
  //     linkUrl:'https://mall.epec.com/ecmall/static/dgclZone.do'
  // },
  // {
  //     productId:7,
  //     productName:'地热产业专区',
  //     describe:'',
  //     imgUrl:require('../../static/characteristicUnit/zhuanqu7.jpg'),
  //     linkUrl:'https://mall.epec.com/ecmall/static/drzq.do'
  // },
  // ],
};
function templateDataInit(dataArr) {
  dataArr.forEach((item) => {
    templateGetItem(item.chunkName, item.fragmentList);
  });
  return templateControlData;
}
function templateGetItem(name, list) {
  const newArr = [];
  list.forEach((item) => {
    newArr.push(JSON.parse(item.templateData));
  });
  if (name === '热搜词') {
    templateControlData.hotWordsList = newArr;
  } else if (name === '轮播图') {
    templateControlData.bannerList = newArr;
  } else if (name === '公告快讯') {
    const nociteList = [];
    const newsList = [];
    newArr.forEach((item) => {
      if (item.type == 1) {
        nociteList.push(item);
      } else if (item.type == 2) {
        newsList.push(item);
      }
    });
    templateControlData.informationList.nociteList = nociteList;
    templateControlData.informationList.newsList = newsList;
  } else if (name === '金刚区视频') {
    templateControlData.videoList = newArr;
  } else if (name === '金刚区') {
    templateControlData.transformersList = newArr;
  } else if (name === '推荐') {
    templateControlData.recommendList = newArr;
  } else if (name === '品类') {
    templateControlData.categoryList = newArr;
  } else if (name === '品牌') {
    templateControlData.brandList = newArr;
  } else if (name === '品牌商城') {
    templateControlData.brandMallList = newArr;
  } else if (name === '我要采购') {
    templateControlData.purchasePgeList = newArr;
  }
}

export {
  filterCurrency,
  dateformate,
  preDate,
  certificateType,
  templateDataInit,
};

export const dialogIndexINfo = {
  safePopupWindow:`<div class="box">
  <div class="box-title">落实质量安全主体责任承诺书</div>

  <p>依据《工业产品生产单位落实质量安全主体责任监督管理规定》（市场监管总局令第75号）和《工业产品销售单位落实质量安全主体责任监督管理规定》（市场监管总局令第76号），为落实产品质量安全主体责任，强化单位主要负责人产品质量安全责任，规范质量安全管理人员行为，易派客平台内经营者特作承诺如下：<p/>
  <p>一、依法配备与单位规模、产品类别、风险等级相适应的质量安全总监和质量安全员，明确主要负责人、质量安全总监和质量安全员的岗位职责。主要负责人对本单位的产品质量安全工作空面负责，质量安全总监、质量安全员按照岗位职责协助销售单位主要负责人做好产品质量安全管理工作。<p/>
  <p>二、主要负责人支持和保障质量安全总监、质量安全员依法开展产品质量安全管理工作，在作出涉及产品质量安全的重大决策前，充分听取质量安全总监和质量安全员的意见和建议。<p/>
  <p>三、为质量安全总监和质量安全员提供必要的工作条件、教育培训和岗位待遇，充分保障其依法履行职责。组织对质量安全总监和质量安全员进行法律法规、标准和专业知识培训、考核，未通过考核的人员不得担任相应岗位的质量安全管理人员。<p/>
  <p>四、建立基于工业产品质量安全风险防控的动态管理机制，结合本单位实际，落实自查要求，制定包括进货查验、索证索票、建立台账、核对产品质量信息等内容的《工业产品质量安全风险管控清单》，建立健全日管控、周排查、月调度工作制度。<p/>
</div>
</div>`,
promisePopupWindow:`<div class="box">
<div class="box-title">正确使用认证证书、检验检测报告的承诺</div>

<p>根据北京市朝阳区市场监督管理局《关于对网络交易平台涉及认证、检验检测行为规范的要求》的相关内容，易派客电子商务有限公司现要求易派客电子商务平台内经营者做出如下承诺：<p/>
<p>一、自身在易派客电子商务平台内销售的被纳入《强制性产品认证目录描述与界定表》的产品，应保证具备有效的《强制性产品认证证书》，并将前述《强制性产品认证证书》清晰完整地展示易派客店铺或商品详情页。<p/>
<p>二、正确使用认证证书、检验检测报告，在易派客电子商务平台展示的前述各类证书、报告应确保真实、有效，并应清晰显示发证机构、颁发日期、证书／报告编号、检测结论、商品名称及规格型号等关键信息。<p/>
<p>此外，为加强易派客电子商务平台商品质量管理工作，经营者如在易派客电子商务平台销售被纳入《强制性产品认证实施规则防爆电气》、《实施强制管理的计量器具目录》、《特种设备生产单位许可目录》的等产品，应保证具备有效的产品认证证书，并将前述证书清晰完整地展示于易派客店铺或商品详情页。<p/></div>`
}
